import { DownloadTypeFormWebComponent } from './component/DownloadTypeFormWebComponent';
import { WEB_COMPONENT_DOWNLOAD_TYPE_FORM } from '../../../../webcomponents.constants';

export { DownloadTypeFormWebComponent };

window.customElements.define(WEB_COMPONENT_DOWNLOAD_TYPE_FORM, DownloadTypeFormWebComponent);
